module.exports = __webpack_public_path__ + "static/media/h5_yoga_pic2.4a568730.png";